<script lang="ts">
	import { useReleaseContext } from '../../context/release';
	import { AlertTriangle, RefreshCw } from 'lucide-svelte';

	// Phase 3: Use cleaner context interface
	const { releaseStore, releaseRuntimeState } = useReleaseContext();

	function handleStartOver() {
		releaseStore.resetRuntime();
	}
</script>

<div class="space-y-8">
	<!-- Error Alert -->
	<div class="alert alert-error animate-slide-up">
		<div class="flex items-start gap-4">
			<div class="w-12 h-12 bg-red-600 text-white rounded-full flex items-center justify-center flex-shrink-0">
				<AlertTriangle size={24} />
			</div>
			<div class="flex-1">
				<h3 class="text-xl font-bold text-red-900 mb-1">Generation Error</h3>
				<p class="text-red-700">Something went wrong during the release generation process</p>
			</div>
		</div>
	</div>

	<!-- Error Details -->
	{#if $releaseRuntimeState.error}
		<div class="card card-hover animate-slide-up">
			<div class="card-body">
				<div class="flex items-start gap-4 mb-6">
					<div class="avatar avatar-md bg-red-600 text-white">
						<AlertTriangle size={24} />
					</div>
					<div>
						<h2 class="text-2xl font-bold text-gray-900 mb-1">Error Details</h2>
						<p class="text-gray-600">Technical information about the error</p>
					</div>
				</div>
				<div class="bg-red-50 border border-red-200 p-6 rounded-xl">
					<code class="text-sm text-red-800 font-mono break-all">{$releaseRuntimeState.error}</code>
				</div>
			</div>
		</div>
	{/if}

	<!-- Action -->
	<div class="card card-hover animate-scale-in">
		<div class="card-body text-center">
			<div class="avatar avatar-lg bg-gradient-to-r from-blue-600 to-purple-600 text-white mx-auto mb-6">
				<RefreshCw size={32} />
			</div>
			<h2 class="text-3xl font-bold text-gray-900 mb-3">Start Over</h2>
			<p class="text-lg text-gray-600 mb-8">Let's try generating your release again</p>
			<button class="btn btn-primary btn-lg" on:click={handleStartOver}>
				<RefreshCw size={20} />
				Start Over
			</button>
		</div>
	</div>
</div>